var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"languages-info__languages"},_vm._l((_vm.languages),function(language){return _c('div',{key:language,staticClass:"languages-info__language",attrs:{"data-lang":language,"title":language}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }